export const USERS_CATALOG = '$users';
export const WEBHOOKS_CATALOG = '$webhooks';
export const SCRIPTS_CATALOG = '$scripts';
export const EVENTS_CATALOG = '$events';
export const PROCESSES_CATALOG = '$processes';
export const AUTH_SERVICES_CATALOG = '$authServices';
export const WEB_REQUESTS_CATALOG = '$webRequests';
export const ACCOUNTS_CATALOG = "$accounts";
export const COMPANIES_CATALOG = "$companies";
export const INVITES_CATALOG = "$invites";
export const APP_TAGS_CATALOG = "$appTags";
export const API_TAGS_CATALOG = "$apiTags";
export const COMPANIES_GROUPS_CATALOG = "$companiesGroups";
export const EMAIL_TEMPLATES_CATALOG = "$emailTemplates";
export const EXTENSIONS_CATALOG = "$extensions";
export const REQUESTS_CATALOG = "$requests";